import ModalPortal from '@Components/Popups/ModalPortal'
import Popup from '@Components/Popups/Popup'
import React from 'react'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import './index.scss'

interface DeleteDraftModalProps {
    open: boolean
    closeModal: () => void
    title?: string
    individual?: boolean
    handleDeleteDraft: () => void
    disabled: boolean
}

const DeleteDraftModal = (props: DeleteDraftModalProps) => (
    <ModalPortal isOpen={props.open} onClose={props.closeModal}>
        <Popup onClose={props.closeModal} className="delete-modal">
            <ConfirmationPopup
                title={`Are you sure you want to delete ${props.individual ? 'this draft' : 'all of your drafts'}?`}
                cancelButtonText="No"
                confirmButtonText="Yes, I want to delete"
                disabled={props.disabled}
                onConfirm={props.handleDeleteDraft}
                onCancel={props.closeModal}
            >
                {props.individual ? (
                    <p>
                        You will lose all information in <b>&quot;{props.title}&quot;</b> and will not be able to
                        recover this draft.
                    </p>
                ) : (
                    <p>You will not be able to recover these drafts and will lose any associated information.</p>
                )}
            </ConfirmationPopup>
        </Popup>
    </ModalPortal>
)

export default DeleteDraftModal
